<template>
	<v-dialog
		v-model="open"
		v-if="open"
		:content-class="`discount-dialog`"
	>
		<v-layout column class="kiosk-modal discount-layout">
			<div class="black-background">
				<v-layout column wrap justify-space-between class="dialog-body-wrapper">
					<v-layout column class="discount-dialog-body">
						<div class="discount-title">{{ $t('utilityComponents.productAsCompensationCRMModule.congrats') }}</div>
						<div class="discount-subtitle">{{ $t('utilityComponents.productAsCompensationCRMModule.youHaveWon') }} {{ product.name }}</div>
						<div class="discount-price">
							{{ awardVoucherItem.discountValue === 100 ?
							$t('utilityComponents.productAsCompensationCRMModule.gratis') :
							$t('utilityComponents.productAsCompensationCRMModule.discountPrice', { percent: awardVoucherItem.discountValue}) }}
						</div>
					</v-layout>
					<img class="product-as-reward-image" :src="getProductImage(product)"/>
					<v-layout column wrap class="discount-dialog-footer">
						<div class="discount-price-section">
							<div class="discount-new-price">
								{{ awardVoucherItem.discountValue === 100 ? $t('utilityComponents.productAsCompensationCRMModule.free') : awardVoucherItem.discountValue + "%" }}
							</div>
						</div>
						<div class="discount-actions">
							<v-btn @click="onClose"
									:ripple="false"
									class="not-now"
									primary
									flat>
								{{ $t('utilityComponents.productAsCompensationCRMModule.notNow') }}
							</v-btn>
							<v-btn @click="takeAward()"
									:ripple="false"
									class="redeem-discount green-btn"
									primary
									flat>
								{{ $t('utilityComponents.productAsCompensationCRMModule.redeemDiscount') }}
							</v-btn>
						</div>
						<div class="unredeemed-discount">{{ $t('utilityComponents.productAsCompensationCRMModule.unredeemedDiscount') }}</div>
					</v-layout>
				</v-layout>
			</div>
		</v-layout>
	</v-dialog>
</template>

<script>
import {voucherValidationHelper} from "../../../../helper/VoucherValidationHelper";
import {addProductToCart} from "../../../../helper/VoucherProductHelper";
import { mapGetters } from "vuex";

export default {
	name: "VoucherCatalogDialog-gt3",
	props: ["show", "onClose", "product", "awardVoucherItem", "getProductImage"],
	computed: {
		open: {
			get() {
				return this.show;
			},
			set() {
				this.onClose();
			}
		},
		...mapGetters(["cartProducts"])
	},
	methods: {
		async takeAward() {
			if (this.cartProducts.map(x=>x.voucherId).filter(Boolean).length) {
				this.$store.commit("SET_GLOBAL_INFO_DIALOG", "utilityComponents.productAsCompensationCRMModule.onlyOneAppliedDiscountAllowed");
			} else {
				await addProductToCart(this, this.product.id, this.awardVoucherItem.voucherId);
				await voucherValidationHelper(this, this.awardVoucherItem.voucherId);
			}
			this.onClose();
		}
	}
};
</script>

<style lang="scss" scoped>

/deep/ .v-dialog.discount-dialog {
	width: 900px;
	height: 750px;
	background-color: #000000;
	color: #FFFFFF;
	margin: auto;
	.discount-layout, .black-background {
		height: 100%;
		padding: 0;
		margin: 0;
	}
	.discount-layout {
		.close-btn {
			position: absolute;
			top: 0;
			right: 0;
		}
		.dialog-body-wrapper {
			height: 100%;
		}
		.discount-dialog-body {
			color: #FFFFFF;
			padding: 40px 25px 0;
			text-align: center;
			font-weight: bold;
			.discount-title {
				font-size: 60px;
				line-height: 1;
				text-transform: uppercase;
			}
			.discount-subtitle, .discount-product, .discount-price {
				font-size: 30px;
				line-height: 40px;
			}
			.discount-price {
				color: #FFD800;
			}
		}
		.discount-dialog-body, .discount-dialog-footer {
			flex: 0 1 auto;
		}
		.discount-dialog-footer {
			margin: 0 15px;
			.redeem-discount {
				width: 50%;
				height: 60px;
				font-size: 22px;
			}
			.not-now {
				width: 50%;
				height: 60px;
				border: 2px solid #ffffff;
				color: #ffffff;
				margin: 6px 8px;
				font-size: 22px;
				font-family: Dispatch-Bold;
			}
			.unredeemed-discount {
				color: white;
				font-size: 14px;
				line-height: 18px;
				text-align: center;
				margin: 15px 0;
			}
			.discount-price-section {
				display: flex;
				justify-content: flex-end;
				margin-bottom: 15px;
				.discount-regular-price {
					background-color: #333333;
					font-size: 20px;
					color: #7B7B7B;
					padding: 7px 15px;
					line-height: 1;
					text-decoration: line-through;
					font-weight: bold;
				}
				.discount-new-price {
					background-color: #FFD800;
					font-size: 20px;
					font-weight: bold;
					padding: 7px 15px;
					line-height: 1;
					text-transform: uppercase;
					color: #000000;
				}
			}
			.discount-actions {
				display: flex;
				width: 100%;
				align-items: center;
				justify-content: center;
			}
		}
	}
	.product-as-reward-image {
		width: 300px;
		margin: auto;
	}
}
</style>
